import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Tabs from '../../../tabs/Tabs'
import FacturaEmisionIndex from './components/FacturaEmisionIndex'
import CreateMasiveFacturas from './components/createMasiveFactura/Index'
import ListadoFacturas from './components/listadoFacturas/ListadoFacturas'
import FacturasProgramadas from './components/facturasProgramadas/FacturasProgramadas'

const TAB_SLUGS = ['emitidas', 'individual', 'masivas', 'programadas']

export default function TabsFacturacion() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [refreshCount, setRefreshCount] = useState(0)
  const [invoiceToClone, setInvoiceToClone] = useState(null)
  const tabParam = searchParams.get('tab')
  const activeTab = TAB_SLUGS.includes(tabParam) ? TAB_SLUGS.indexOf(tabParam) : 0

  const navigateToTab = index => {
    setSearchParams({ tab: TAB_SLUGS[index] }, { replace: true })
  }

  const handleTabClick = index => {
    navigateToTab(index)
    setInvoiceToClone(null)
  }

  const handleEmitSuccess = (switchTab = true) => {
    setRefreshCount(prev => prev + 1)
    setInvoiceToClone(null)
    if (switchTab) navigateToTab(0)
  }

  const tabs = [
    {
      title: 'Facturas emitidas',
      content: (
        <div className='py-6'>
          <ListadoFacturas
            refreshTrigger={refreshCount}
            onCloneRequest={doc => {
              setInvoiceToClone(doc)
              navigateToTab(1)
            }}
          />
        </div>
      )
    },
    {
      title: 'Emitir factura individual',
      content: (
        <div className='space-y-6'>
          <FacturaEmisionIndex
            onEmitSuccess={handleEmitSuccess}
            initialDocToClone={invoiceToClone}
          />
        </div>
      )
    },
    {
      title: 'Emitir facturas masivas',
      content: (
        <div className='space-y-6'>
          <CreateMasiveFacturas onEmitSuccess={handleEmitSuccess} />
        </div>
      )
    },
    {
      title: 'Facturas programadas',
      content: (
        <div className='space-y-6'>
          <FacturasProgramadas />
        </div>
      )
    }
  ]

  return <Tabs tabs={tabs} activeIndex={activeTab} onTabClick={handleTabClick} />
}
